module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-header.fe2af6fe.png";